/* eslint-disable import/no-unresolved */
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import CustomLabel from "../../../../../shared/CustomLabel";
import CustomReviewField from "../../../../../shared/CustomReviewField";

function AssignmentNotice() {
  const assignmentNotice = useAppSelector((state) => state.assignmentClauseDetails);
  const mefSchema = useAppSelector((state) => state.masterdata_reducer?.mefJourneySchema);
  const assignmentMefFields = mefSchema?.assignmentNotice || {};
  return (
    <div>
      <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 lg:gap-x-32 md:gap-x-36 gap-x-3 mt-6 max-sm:ml-4 ">
        {(assignmentNotice?.assignor || assignmentMefFields?.assignor?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.assignor?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.assignor || "-"}</CustomReviewField>
          </div>
        )}

        {(assignmentNotice?.assignorJoint || assignmentMefFields?.assignorJoint?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.assignorJoint?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.assignorJoint || "-"}</CustomReviewField>
          </div>
        )}

        {(assignmentNotice?.assignorName || assignmentMefFields?.assignorName?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.assignorName?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.assignorName || "-"}</CustomReviewField>
          </div>
        )}

        {(assignmentNotice?.assigmentAt || assignmentMefFields?.assigmentAt?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.assigmentAt?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.assigmentAt || "-"}</CustomReviewField>
          </div>
        )}

        {(assignmentNotice?.signedDate || assignmentMefFields?.signedDate?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.signedDate?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.signedDate || "-"}</CustomReviewField>
          </div>
        )}

        {(assignmentNotice?.place || assignmentMefFields?.place?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.place?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.place || "-"}</CustomReviewField>
          </div>
        )}

        {(assignmentNotice?.reasonForAssigment ||
          assignmentMefFields?.reasonForAssigment?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.reasonForAssigment?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.reasonForAssigment || "-"}</CustomReviewField>
          </div>
        )}
      </div>
      <div className="flex justify-between mt-8">
        <div className="text-base font-bold">Witness Details</div>
      </div>
      <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 lg:gap-x-32 md:gap-x-36 gap-x-3 mt-6 max-sm:ml-4 ">
        {(assignmentNotice?.witnessName || assignmentMefFields?.witnessName?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.witnessName?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.witnessName || "-"}</CustomReviewField>
          </div>
        )}

        {(assignmentNotice?.address || assignmentMefFields?.address?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.address?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.address || "-"}</CustomReviewField>
          </div>
        )}

        {(assignmentNotice?.pincode || assignmentMefFields?.pincode?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.pincode?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.pincode || "-"}</CustomReviewField>
          </div>
        )}

        {(assignmentNotice?.occupation || assignmentMefFields?.occupation?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{assignmentMefFields?.occupation?.label}</CustomLabel>
            <CustomReviewField>{assignmentNotice?.occupation || "-"}</CustomReviewField>
          </div>
        )}
      </div>
    </div>
  );
}
export default AssignmentNotice;
